/* eslint-disable no-unused-vars */
import { RootMutationTypes } from './types';

export const actions = {
    async SetDeleteFilterStatus({ commit }, { status }) {
        commit(RootMutationTypes.SetDeleteFilterStatus, { status })
    },
}